import cityComponent from './city.component';

const cityModule = angular.module('city', [
])
  .component('city', cityComponent)
  .name;

export default cityModule;
